import { HttpResourceRef } from '@angular/common/http';
import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { ItemListResponse } from '@models';

@Component({
  selector: 'app-list',
  imports: [MatButtonModule, MatIconModule, RouterLink],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss'
})
export class ListComponent {
  resource = input<HttpResourceRef<ItemListResponse<unknown> | undefined>>();
  disableClear = input(false);
}
